import { ref } from 'vue';
import bookAppointmentApi from '../../../api/bookappointment-api';
const STATES = {
	INIT: Symbol('INIT'),
	LOADING: Symbol('LOADING'),
	SUCCESS: Symbol('SUCCESS'),
	ERROR: Symbol('ERROR')
};
const state = ref(STATES.INIT);
const themeId = ref(null);
const theme = ref(null);

export const useTheme = () => {
	const setTheme = (themeIdVal) => {
		theme.value = themeIdVal;
	};
	const setThemeId = (themeIdVal) => {
		themeId.value = themeIdVal;
	};
	const getTheme = async (temaId) => {
		try {
			setThemeId(temaId);
			state.value = STATES.LOADING;
			const { data } = await bookAppointmentApi.getTheme(temaId);
			state.value = STATES.SUCCESS;
			setTheme(data);
		} catch (err) {
			state.value = STATES.ERROR;
		}
	};
	return {
		theme,
		themeId,
		getTheme,
		setTheme,
		setThemeId
	};
};
